import i18n from '@/i18n'

export default [
  {
    path: '/l4Proxy',
    meta: {
      title: i18n.t('menu.l4Proxy'),
      leftMenuCode: 'Configurations'
    },
    component: () => import('@/views/l4Proxy/index.vue')
  }
]
